type SubscriptionInfo = {
    success: boolean,
    status: string | null,
    name?: string | null,
    location?: string | null,
    supporting?: string | null,
    subscription_type?: string | null,
    subscription_amount?: number | null,
};

async function fetchSubscription(id: number): Promise<SubscriptionInfo> {
    try {
        const response = await fetch(`/account/subscriptions/${id}.json`);
        return await response.json();
    } catch (e) {
        return { success: false, status: "fetch_error" };
    }
}

function setText(element: HTMLElement | null, text: string | null | undefined) {
    if (element) {
        element.replaceChildren();
        element.innerText = text ?? "—";
    }
}

function setStatusMessage(el: HTMLElement, text: string) {
    const headerRow = el.querySelector(".header-row");

    const message = document.createElement("p");
    message.classList.add("status-message");
    message.innerText = text;

    headerRow?.insertAdjacentElement("afterend", message);
}

async function fillCardDetails(el: HTMLElement, subscriptionId: number) {
    const sub = await fetchSubscription(subscriptionId);

    setText(el.querySelector("[data-subscription-title]"),
        sub.subscription_type && sub.subscription_amount ?
            `${sub.subscription_type} — $${sub.subscription_amount}` : "Subscription");

    setText(el.querySelector("[data-subscription-name]"), sub.name);
    setText(el.querySelector("[data-subscription-location]"), sub.location);
    setText(el.querySelector("[data-subscription-supporting]"), sub.supporting);

    if (!sub.success) {
        setStatusMessage(el, sub.status === "not_processed"
            ? "Your subscription is being processed"
            : "Cannot retrieve subscription, please try again later");
    }
}

export default function subscriptionCard(el: HTMLElement, subscriptionId: number) {
    fillCardDetails(el, subscriptionId);
}
